module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-break-cdb8c642.svg";